const PGAdapter = require('../../common/pg-adapter')
const PAYMENT_TABLE_NAME = '"avocado"."data_payment"'
const PAYMENT_TABLE_COLUMNS = [
  'location_id',
  'payment_provider',
  'payment_method',
  'currency',
  'amount_in_cents',
  'total_amount',
  'created_by',
  'email',
  'payment_data',
  'order_id',
  'created_at',
  'updated_at',
  'status',
  'error_code',
  'invoice_id'
]

const orderTransactionLegacyQuery = `
  select qt.*
  from avocado.data_invoice_line l
  left join avocado.data_invoice i on l.invoice_id = i.id
  left join avocado.data_invoice_quickbooks ql on ql.invoice_id = i.id
  left join avocado.data_quickbookstransactions qt on qt.txn_id = ql.invoice_txn_id and qt.company_code = ql.company_code
  where l.order_id = $1
    and qt.id is not null
  limit 1
`

// Oldest invoice of the order; the fin read only has the fields the callers use.
// fin amounts are numeric, the legacy table has float8, hence the casts.
const orderTransactionFinQuery = `
  select
    i.location_id,
    fi.company::text as company_code,
    fi.txn_id::text as txn_id,
    fi.doc_no as quickbooks_doc_number,
    fi.txn_type::text as txn_type,
    fi.txn_date::date as txn_date,
    fi.due_date,
    fi.amount::float8 as amount,
    (fi.amount - fi.balance)::float8 as amount_paid,
    fi.order_type
  from avocado.data_invoice_line l
  inner join avocado.data_invoice i on l.invoice_id = i.id
  inner join avocado.data_invoice_quickbooks ql on ql.invoice_id = i.id and ql.company_code != 'LEGACY'
  inner join fin.invoice fi
          on fi.origin = 'qbo'
         and fi.company = ql.company_code::fin.company_type
         and fi.txn_id = ql.invoice_txn_id::integer
  where l.order_id = $1
  order by fi.txn_date, fi.txn_id
  limit 1
`

class PaymentDbAdapter extends PGAdapter {
  constructor (
    pgConnection,
    username
  ) {
    super(pgConnection, PAYMENT_TABLE_NAME, username, PAYMENT_TABLE_COLUMNS)
    this.pgConnection = pgConnection
    this.pgAdapter = new PGAdapter(pgConnection, PAYMENT_TABLE_NAME, username, PAYMENT_TABLE_COLUMNS)
  }

  async getOrderTransactions (orderId, { useFin = false } = {}) {
    const query = useFin ? orderTransactionFinQuery : orderTransactionLegacyQuery
    const { rows } = await this.pgConnection.query(query, [orderId])
    return rows[0]
  }
}

module.exports = PaymentDbAdapter
module.exports.orderTransactionLegacyQuery = orderTransactionLegacyQuery
module.exports.orderTransactionFinQuery = orderTransactionFinQuery
